<template>
  <Modal
    :visible="isOpen"
    :size="size"
    @ok="handleOk"
    @cancel="handleCancel"
    class="h-5/6"
  >
    <div>
      <div class="modal-body">
        <div class="category-header">
          <div v-if="numberOfImage" class="current-image-num">
            {{ activeIndex + 1 }}/{{ totalImage }}
          </div>
        </div>
        <!-- <CarouselThumbnail previewOnly :slides="loadSlides" @change="activeImage = $event"/> -->
        <BasicCarousel
          :activeIndex="imageIndex"
          showLabel
          :images="loadSlides"
          :isShowThumbnail="false"
          :imageFull="true"
          :isShowIndicator="false"
        />
      </div>
      <div class="modal-footer">
        <p v-if="activeImage">
          {{ activeImage.alt }}
        </p>
      </div>
    </div>
  </Modal>
</template>

<script>
// import _ from 'lodash'
import { Modal } from '@/components/primitive'

export default {
  components: {
    Modal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    numberOfImage: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'large' // small, medium, large
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    imageIndex: {
      default: null
    },
    categoryImage: {
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      selectedCategory: null,
      activeImage: null,
      dataBinding: [],
      slides: [],
      dataImg: {},
      ImgCategory: [],
      activeIndex: 0,
      totalImage: 0
    }
  },
  beforeMount() {
    this.dataImg = this.value
  },
  mounted() {
    if (this.visible) {
      this.isOpen = this.visible
    }
  },
  watch: {
    visible(val) {
      this.isOpen = val
    }
  },

  computed: {
    imageCategories() {
      return []
    },
    loadSlides() {
      return (this.value || []).map((e) => {
        e.label = e.imageExplanation
        return e
      })
    }
  },
  methods: {
    statusSelect(category, index) {
      for (let i = 0; i < this.dataPhotoGallery.length; i++) {
        if (this.dataPhotoGallery[i].status !== this.dataPhotoGallery[index].status) {
          this.dataPhotoGallery[i].status = false
        }
      }
      category.status = !category.status
    },

    onSelectCategory(category) {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        this.selectedCategory = null
      } else {
        this.selectedCategory = category
      }
    },
    onChangeCarousel($event) {
      this.activeIndex = $event.index
      this.totalImage = $event.total
    },
    handleOk() {
      this.selectedCategory = null
      this.$emit('ok')
    },
    handleCancel() {
      this.selectedCategory = null
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>
